

























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CardCollapsable from "@/components/CardCollapsable.vue";
import { SaveStatus, Status } from "@/modules/simulator/store";

@Component({
    components: {
        CardCollapsable
    }
})
export default class Calculate extends Vue {
    @Prop({ type: String, required: true })
    public namespace!: string;

    public aborting: boolean = false;

    get saveStatus(): SaveStatus {
        return this.$store.state[this.namespace].simulator.saveStatus;
    }

    get status(): Status {
        return this.$store.state[this.namespace].simulator.status;
    }

    get log(): string {
        return this.$store.state[this.namespace].simulator.log;
    }

    get Status() {
        return Status;
    }

    get SaveStatus() {
        return SaveStatus;
    }

    @Watch("status")
    async watchStatus(status) {
        if (status !== Status.running) {
            this.aborting = false;
        }
        if (status === Status.failed) {
            await this.$nextTick();
            (this.$refs.logCollapse as any).setVisible(true);
        } else if (status === Status.success) {
            await this.$nextTick();
            (this.$refs.logCollapse as any).setVisible(false);
        }
    }

    public simulate(): Promise<void> {
        return this.$store.dispatch(`${this.namespace}/simulator/simulate`);
    }

    public stopSimulation(): void {
        this.aborting = true;
        setTimeout(() => {
            this.$store.dispatch(`${this.namespace}/simulator/stopSimulation`);
        }, 1000);
    }
}
